<section>
  <div class="header astral-page-header">
    <h1>{{ 'DASHBOARD.MENU.REPORT_STAIRCASE_LIST' | translate }}</h1>
  </div>

  <app-information-block [text]="'REPORT.HEADER_TOOLTIP.STAIRCASE_LIST' | translate"></app-information-block>

  <form class="filter astral-section-surface astral-form-stack astral-form-stack--relaxed report-filter-surface" [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
    <astral-layout-group [columns]="6" [tabletColumns]="2" [mobileColumns]="1">
      <astral-select [control]="form.controls['company']" [itemsSource]="companies"></astral-select>
      <app-autocomplete-remote-paged
        [service]="propertyService"
        [defaultSearch]="'*'"
        [control]="form.controls['property']"
      ></app-autocomplete-remote-paged>
      <app-autocomplete-remote-paged
        [service]="buildingService"
        [defaultSearch]="'*'"
        [control]="form.controls['buildingId']"
      ></app-autocomplete-remote-paged>
      <app-autocomplete-remote-paged
        [service]="entranceService"
        [defaultSearch]="'*'"
        [control]="form.controls['entranceId']"
      ></app-autocomplete-remote-paged>
      <astral-date-picker
        [control]="form.controls['displayDate']"
        [label]="'COMMON.DISPLAY'"
        [model]="displayDate"
        [isRequired]="true"
      ></astral-date-picker>
      <astral-select [control]="form.controls['floorSortOrder']" [itemsSource]="floorSortOrderSelection"></astral-select>
      <astral-select [control]="form.controls['includePremises']" [itemsSource]="includePremisesSelection"></astral-select>
      <astral-remote-multi-select
        [service]="premisesRentalObjectTypeSearchService"
        [defaultSearch]="'*'"
        [control]="form.controls['premisesRentalObjectTypeIds']"
      ></astral-remote-multi-select>
    </astral-layout-group>
    <div class="astral-filter-actions">
      <astral-button variant="primary" size="small" type="submit" icon="search" labelKey="SEARCH_BTN"></astral-button>
    </div>
  </form>
</section>
